import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '@/components/PageHeader';
import { usageService } from '@/api/services/usage';

export default function BillingSuccessPage() {
  const [active, setActive] = useState<boolean | null>(null);
  const [planSlug, setPlanSlug] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    let attempts = 0;

    const poll = async () => {
      attempts += 1;
      try {
        const usage = await usageService.summary('current_month');
        if (cancelled) return;
        setActive(usage.subscriptionActive);
        setPlanSlug(usage.planSlug ?? null);
        if (!usage.subscriptionActive && attempts < 12) {
          window.setTimeout(poll, 2000);
        }
      } catch {
        if (!cancelled && attempts < 12) {
          window.setTimeout(poll, 2000);
        }
      }
    };

    poll();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <PageHeader title="Payment successful" subtitle="Your subscription is being activated" />
      <section className="card section">
        <p>Thank you! Your payment provider is processing your subscription.</p>
        {active === true ? (
          <p>
            Your plan <strong>{planSlug ?? 'subscription'}</strong> is now active.
          </p>
        ) : active === false ? (
          <p className="muted">Activation is still in progress — this usually takes a few seconds.</p>
        ) : (
          <p className="muted">Checking subscription status…</p>
        )}
        <Link to="/usage" className="btn btn-primary">
          View usage
        </Link>{' '}
        <Link to="/" className="btn">
          Back to dashboard
        </Link>
      </section>
    </div>
  );
}
